// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import Finito from "./../../services/finito-service";
import BaoDialog from "./../../factories/bao-dialog";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/foreach-selection";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-searcher";
function OrgUnitTagViewModel(tabPage, orgUnitViewModel) {
    var self = this;
    self.TabPage = tabPage;
    self.OrgUnitViewModel = orgUnitViewModel;
    self.Selection = ko.observableArray();
    self.SelectedTags = ko.observableArray();
    self.Sorting = ko.observableArray();
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.TotalRows = ko.observable();
    self.Models = ko.observableArray([]);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.Selection.subscribe(function () {
        self.toggleButtons();
    });
    self.SelectedTags.subscribe(function (selectedItems) {
        if (selectedItems != null && selectedItems.length > 0) {
            var tagIds = [];
            ko.utils.arrayForEach(selectedItems, function (item: any) {
                tagIds.push(ko.unwrap(item.TagId));
            });
            self.addTagToSession(tagIds);
        }
    });
    self.toolbarButtonClicked = function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            var functionString = btn.ActionKey().substr(("OrgUnitCustomToolbarTag").length);
            switch (functionString) {
                case "Add":
                    self.addTag();
                    break;
                case "Remove":
                    var promptDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("DeleteOrgUnitTag"), "question");
                    promptDialog.DialogResult.subscribe(function (res) {
                        if (res) {
                            self.removeTag();
                        }
                    });
                    break;
                default:
                    break;
            }
        }
    };
    self.toolbarLoaded = function () {
        self.toggleButtons();
    };
    self.addTag = function (item) {
        this.openTagSearcher();
    };
    self.openTagSearcher = function () { };
}
;
OrgUnitTagViewModel.prototype.toggleButtons = function () {
    if (this.enableButton != undefined) {
        var selection = this.Selection.peek();
        this.enableButton("OrgUnitCustomToolbarTagRemove", selection && selection.length > 0);
    }
};
OrgUnitTagViewModel.prototype.removeTag = function (a, b, c) {
    var self = this;
    self.TabPage.IsLoading(true);
    var tagIds = [];
    ko.utils.arrayForEach(self.Selection(), function (item: any) {
        tagIds.push(ko.unwrap(item.TagId));
    });
    return Bao.post("OrgUnit/DeleteTag", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId(),
        orgUnitId: self.OrgUnitViewModel.OrgUnitId(),
        tagIds: tagIds
    }), function () {
        self.OrgUnitViewModel.TabPage.DirtyFlag(true);
        self.RefreshGrid();
    });
};
OrgUnitTagViewModel.prototype.RefreshGrid = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("OrgUnit/GetTag", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId(),
        orgUnitId: self.OrgUnitViewModel.OrgUnitId(),
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting()
    }), function (searchResult) {
        self.SelectedTags([]);
        self.TotalRows(0);
        self.Models([]);
        if (searchResult != null && searchResult.Models != null) {
            self.Models(searchResult.Models);
            self.TotalRows(searchResult.TotalRows);
            self.toggleButtons();
        }
        self.TabPage.IsLoading(false);
    });
};
OrgUnitTagViewModel.prototype.Refresh = function () {
    var self = this;
    var def = $.Deferred();
    self.Selection([]);
    Bao.post("OrgUnit/ResetTagOrgUnit", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId()
    }), function () {
        self.RefreshGrid().then(function () {
            def.resolve();
        });
    });
    return def.promise();
};
OrgUnitTagViewModel.prototype.addTagToSession = function (tagIds) {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("OrgUnit/AddTag", JSON.stringify({
        sessionTabId: self.OrgUnitViewModel.SessionTabId(),
        orgUnitId: self.OrgUnitViewModel.OrgUnitId(),
        tagIds: tagIds
    }), function () {
        self.OrgUnitViewModel.TabPage.DirtyFlag(true);
        self.RefreshGrid();
    });
};
export default OrgUnitTagViewModel;